/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_CreateInputs */

const he_posts_create = /** @type {(inputs: Posts_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צור פוסט`)
};

const en_posts_create = /** @type {(inputs: Posts_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Post`)
};

/**
* | output |
* | --- |
* | "Create Post" |
*
* @param {Posts_CreateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_create = /** @type {((inputs?: Posts_CreateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_CreateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_create(inputs)
	return en_posts_create(inputs)
});